module.exports = __webpack_public_path__ + "img/03zs.d8ab5383.png";